import player from './player'
import sceneTools from './scene'

const translate = function (objectNames, position) {
    let nodes = []
    objectNames.forEach(element => {
        nodes = nodes.concat(sceneTools.getNodeFromGraphByNameAndType(null, element, 'MatrixTransform', true))        
    });

    let api = player.getApi()
    if (api) {
        nodes.forEach(node => {
            api.translate(node.instanceID, position, 5000, 'easeOutQuad', function(err, translateTo) {
            })
        });
    }    
}


export default {
  translate
}
